import { Link, useParams, useSearchParams } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import SpecialOrderForm from "../components/SpecialOrder/SpecialOrderForm";
import {
  COPY_FROM_PARAM,
  SPECIAL_ORDER_PATH,
} from "../components/SpecialOrder/data";

/** /special-orders/new (optionally ?copy_from=<uuid>) and /special-orders/:uuid/edit. */
export default function SpecialOrderFormPage() {
  const { uuid } = useParams<{ uuid: string }>();
  const [searchParams] = useSearchParams();
  const copyFrom = uuid ? undefined : searchParams.get(COPY_FROM_PARAM) ?? undefined;

  return (
    <Box sx={{ padding: "8px 0" }}>
      <Box display="flex" alignItems="center" mb={2}>
        <Link to={SPECIAL_ORDER_PATH} style={{ textDecoration: "none", color: "inherit" }}>
          <Typography variant="body1" fontWeight={500}>
            ออเดอร์พิเศษ
          </Typography>
        </Link>
        <Typography variant="body1" sx={{ mx: 1 }}>
          /
        </Typography>
        <Typography variant="body1" color="primary">
          {uuid ? "แก้ไขร่าง" : "สร้างใหม่"}
        </Typography>
      </Box>
      {/* Keyed so moving between new / copy / edit starts from a clean form. */}
      <SpecialOrderForm key={uuid ?? copyFrom ?? "new"} uuid={uuid} copyFrom={copyFrom} />
    </Box>
  );
}
